// extracted by mini-css-extract-plugin
module.exports = {"selectDiv":"transfer_selectDiv__3145V"};